var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinusCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1008 1008",
  width: "1em",
  height: "1em",
  role: "img",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M504 72C266 72 72 266 72 504s194 432 432 432 432-194 432-432S742 72 504 72m0-72c278 0 504 226 504 504s-226 504-504 504S0 782 0 504 226 0 504 0m288 540v-72H216v72z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinusCircle);
export default ForwardRef;